export default __webpack_public_path__ + "static/media/Personal-Information.6fe3cf63.svg";